import { Fragment, useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { StampCertificateEditCrumbs } from 'civil-status/constants/breadcrumb';
import FormStampCertificate, {
  StampCertificateForm,
} from 'civil-status/components/stamp-certificate/form';
import { useNavigate, useParams } from 'react-router-dom';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { transformResponseStampCertificate } from 'civil-status/utils/transformer-stamp-certificate';
import { __CIVIL_STATUS_API_URL__ } from 'shell/constants/environment';
import { HttpResponse } from 'shell/models/http-response';
import { StampCertificate } from 'shell/models/stamp-certificate';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { toast } from 'react-toastify';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';

const StampCertificateEditPage = (): React.ReactElement => {
  const navigate = useNavigate();

  const params = useParams();

  const [stampCertificate] = useHttpFetch<HttpResponse<StampCertificate>, StampCertificateForm>(
    `${__CIVIL_STATUS_API_URL__}/testo-stampa-certificazione/${params.id}`,
    {
      onBootstrap: true,
      transformer: transformResponseStampCertificate,
    }
  );

  const isLoading =
    stampCertificate.isLoading || stampCertificate.pristine || stampCertificate.hasErrors;

  const updateStampCertificate = useHttpClient(
    `${__CIVIL_STATUS_API_URL__}/testo-stampa-certificazione/aggiornamento-testo-stampa-certificazione`,
    {
      options: {
        method: 'PUT',
      },
    }
  );

  const handleSubmit = useCallback(
    (values: StampCertificateForm) => {
      (
        updateStampCertificate({
          data: {
            key: {
              codiceTesto: values.code,
            },
            tipoElemento: values.printElement,
            testoStampa: values.text,
            tipoStampa: values.type,
            tipoAtto: values.typeAct,
            codiceModificatore: values.editor,
          },
        }) as ResponsePromise<void>
      ).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/stato-civile/timbri');
      });
    },
    [updateStampCertificate, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs items={StampCertificateEditCrumbs} />
      {isLoading ? undefined : (
        <FormStampCertificate
          title={'Modifica Timbro Certificato'}
          onOk={handleSubmit}
          onCancel={() => {
            navigate('/stato-civile/timbri');
          }}
          isEdit
          initialValues={stampCertificate.data as StampCertificateForm}
        ></FormStampCertificate>
      )}
    </Fragment>
  );
};

StampCertificateEditPage.displayName = 'Stamp Certificate Edit page component';

export default StampCertificateEditPage;
